import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    name: "",
    user: null,
    userData: null,
    userPrivateData: null,
    notifications: null,
    friends: null,
    friendsData: null,
    acceptedPolicies: false
  },
  mutations: {
    updateUserData(state, { userData }) {
      Vue.set(state, "userData", userData);
    },
    updateUserPrivateData(state, { userPrivateData }) {
      Vue.set(state, "userPrivateData", userPrivateData);
    },
    updateUser(state, { user }) {
      Vue.set(state, "user", user);
    },
    updateNotifications(state, { notifications }) {
      Vue.set(state, "notifications", notifications);
    },
    updateFriends(state, { friends }) {
      Vue.set(state, "friends", friends);
    },
    updateFriendsData(state, { friendsData }) {
      Vue.set(state, "friendsData", friendsData);
    },
    updateAcceptedPolicies(state, update) {
      Vue.set(state, "acceptedPolicies", update);
    }
  },
  getters: {
    userData: state => state.userData,
    userPrivateData: state => state.userPrivateData,
    notifications: state => state.notifications,
    user: state => state.user,
    friends: state => state.friends,
    friendsData: state => state.friendsData,
    acceptedPolicies: state => state.acceptedPolicies
  },
  actions: {}
});
